// removed by extract-text-webpack-plugin
module.exports = {"discount-table":"app-components-receipt-commons-ListItemBox-__DiscountTable___A2jNA","discount-cell":"app-components-receipt-commons-ListItemBox-__DiscountTable___3MCdB","discount":"app-components-receipt-commons-ListItemBox-__DiscountTable___3ALcx","text-center":"app-components-receipt-commons-ListItemBox-__DiscountTable___ch6rF","text-right":"app-components-receipt-commons-ListItemBox-__DiscountTable___2Xx6d","text-left":"app-components-receipt-commons-ListItemBox-__DiscountTable___39p77"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/commons/ListItemBox/DiscountTable.css
// module id = 2227
// module chunks = 0